import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { headers, getProformaListUrl, GET_PROFORMA_LIST_ACTION, fetchAuthReport, proformaInvoiceRpt, GET_PROFORMA_RPT_ACTION_TYPE, shareProformaUrl, SHARE_PROFORMA_ACTION } from "../../utils/constants"

export const get_proformaList_action = (CompanyName, ProformaInvoiceDate, ProformaInvoiceNo) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') != '' && sessionStorage.getItem('UserIDSS') != null ? sessionStorage.getItem('UserIDSS') : null,
            MemberID: sessionStorage.getItem('RoleIDSS') == 5 ? sessionStorage.getItem("MemberIDSS") : null,
            CompanyName: CompanyName ? CompanyName : null,
            ProformaInvoiceDate: ProformaInvoiceDate ? ProformaInvoiceDate : null,
            ProformaInvoiceNo: ProformaInvoiceNo ? ProformaInvoiceNo : null
        }
        const res = await axiosGet(getProformaListUrl, mapdata, headers);

        dispatch({
            type: GET_PROFORMA_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const proformaInvoiceRpt_action = (MemberID) => async (dispatch) => {
    try {
        var list = [];
        const mapdata1 = {
            "ParameterName": "@MemberID",
            "ParameterValue": MemberID,
            "ParameterDataType": "int"
        }
        list.push(mapdata1);
        const mapData = {
            "report_name": proformaInvoiceRpt,
            "parameter_details": list
        }
        const res = await axiosPost(fetchAuthReport, mapData, headers);
        dispatch({
            type: GET_PROFORMA_RPT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const share_proforma_action = (MemberID, ProformaInvoiceNo) => async (dispatch) => {
    try {
        const mapdata = {
            MemberID: MemberID,
            ProformaInvoiceNo: ProformaInvoiceNo,
        }

        const res = await axiosGet(shareProformaUrl, mapdata, headers);
        console.log("share_credential_action res", res)

        dispatch({
            type: SHARE_PROFORMA_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}
